export const MANUAL = 'manual';
export const TEAMS = 'teams';
